import { Component } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import * as moment from 'moment';
import { DateFormat, StorageKeyNamesCommon } from 'src/app/constants';
import { StorageService } from 'src/app/shared/services/storage.service';
import { SharedService } from 'src/app/shared/shared.service';
import { ResourceTypeFilterComponent } from '../../custom-filters/audit-logs/resource-type-filter/resource-type-filter.component';
import { ResourceNameFilterComponent } from '../../custom-filters/audit-logs/resource-name-filter/resource-name-filter.component';
import { UserIdFilterComponent } from '../../custom-filters/audit-logs/user-id-filter/user-id-filter.component';
import { UpdatedFilterComponent } from '../../custom-filters/audit-logs/updated-filter/updated-filter.component';
import { ServerSideGridBase } from '../server-side-grid.base';
import { AulogsTooltip } from './aulogs-tooltip.component';

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.scss'],
})
export class AuditLogsComponent extends ServerSideGridBase {

  protected storageKey = StorageKeyNamesCommon.auditLogs;
  protected gridIdSuffix = 'auditlogsGrid';

  protected initialFilters = {
    'resource-type': '',
    'resource-name': '',
    'user-id': '',
    'start-date-utc': '',
    'end-date-utc': '',
  };

  protected initialSorts = {
    resource_name: '',
    resource_type: '',
    ip_address: '',
    user_id: '',
    operation_type: '',
    updated_datetime_utc: '',
  };

  override defaultColDef: ColDef = {
    sortable: true,
    comparator: () => 0,
    filter: false,
    headerTooltip: '',
    tooltipComponent: AulogsTooltip,
    tooltipField: 'resource_type',
    cellDataType: false,
    flex: 1,
    minWidth: 140,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Resource Type',
      field: 'resource_type',
      filter: 'resourceTypeFilter',
      valueGetter: params => {
        const resource_type = params.data.resource_type;
        if (resource_type === 'PARTNER_APP') {
          return 'CSP_APP';
        } else if (resource_type === 'PARTNER') {
          return 'CSP';
        } else {
          return resource_type;
        }
      },
    },
    {
      headerName: 'Resource Name',
      field: 'resource_name',
      filter: 'resourceNameFilter',
    },
    {
      headerName: 'IP Address',
      field: 'ip_address',
    },
    {
      headerName: 'User ID',
      field: 'user_id',
      filter: 'userIdFilter',
      minWidth: 220,
    },
    {
      headerName: 'Operation Type',
      field: 'operation_type',
    },
    {
      headerName: 'Updated On',
      minWidth: 210,
      field: 'updated_datetime_utc',
      filter: 'updatedFilter',
      valueGetter: params => {
        return moment.utc(params.data.updated_datetime_utc).local().format(DateFormat.formatA);
      },
    },
  ];

  frameworkComponents = {
    resourceTypeFilter: ResourceTypeFilterComponent,
    resourceNameFilter: ResourceNameFilterComponent,
    userIdFilter: UserIdFilterComponent,
    updatedFilter: UpdatedFilterComponent,
  };

  constructor(storageService: StorageService, sharedService: SharedService) {
    super(storageService, sharedService);
  }

  protected mapFilterModel(filterModel: any): void {
    if (filterModel.resource_type) {
      const v = filterModel.resource_type.value;
      this.urlParams.filters['resource-type'] =
        v === 'CSP_APP' ? 'PARTNER_APP' : v === 'CSP' ? 'PARTNER' : v;
    } else {
      this.urlParams.filters['resource-type'] = '';
    }

    this.urlParams.filters['resource-name'] = filterModel.resource_name ? filterModel.resource_name.value : '';
    this.urlParams.filters['user-id'] = filterModel.user_id ? filterModel.user_id.value : '';

    if (filterModel.updated_datetime_utc) {
      const f = filterModel.updated_datetime_utc.value.from;
      const t = filterModel.updated_datetime_utc.value.to;
      const start = `${f.year}-${f.month}-${f.day}`;
      const end = `${t.year}-${t.month}-${t.day}`;
      this.urlParams.filters['start-date-utc'] = moment.utc(start).format();
      this.urlParams.filters['end-date-utc'] = moment.utc(end).format();
    } else {
      this.urlParams.filters['start-date-utc'] = '';
      this.urlParams.filters['end-date-utc'] = '';
    }
  }

  protected mapSortModel(sortModel: any[]): void {
    Object.keys(this.urlParams.sorts).forEach(k => (this.urlParams.sorts[k] = ''));
    sortModel.forEach((elem: any) => {
      if (elem.colId in this.urlParams.sorts) {
        this.urlParams.sorts[elem.colId] = elem.sort;
      }
    });
  }
}
